module.exports = __webpack_public_path__ + "static/media/activityIntro3.c83663ca.png";